import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiModel } from './api.model';
import { Referral, ReferralStatus } from '../../authentication/signup/types';

@Injectable()
export class ReferralModel {
    constructor(private apiModel: ApiModel) {}

    public getReferral(referralId: string): Observable<Referral> {
        return this.apiModel.makeHttpObservableRequest({
            method: 'GET',
            url: `${this.apiModel.getReferralEndpoint()}/${referralId}`
        });
    }

    public updateReferral(referralId: string, status: ReferralStatus) {
        return this.apiModel.makeHttpRequest({
            method: 'PUT',
            url: `${this.apiModel.getReferralEndpoint()}`,
            body: {
                id: referralId,
                status
            }
        });
    }
}
